/** Live by default. Set VITE_MICROSERVICE_DATA_MODE=dummy only for local UI previews. */
export function isMicroserviceDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_MICROSERVICE_DATA_MODE ?? 'live',
) {
  return mode === 'dummy' && /^\/resources\/microservice(?:\/|$)/.test(pathname)
}

export function isApigeeProxyDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_APIGEE_PROXY_DATA_MODE ?? 'live',
) {
  return mode === 'dummy' && /^\/resources\/apigee-proxy(?:\/|$)/.test(pathname)
}

export function isApigeeSharedFlowDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_APIGEE_SHARED_FLOW_DATA_MODE ?? 'live',
) {
  return (
    mode === 'dummy' &&
    /^\/resources\/apigee-shared-flow(?:\/|$)/.test(pathname)
  )
}

export function isKongGatewayServiceDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_KONG_GATEWAY_DATA_MODE ?? 'live',
) {
  return (
    mode === 'dummy' &&
    /^\/resources\/kong-gateway-service(?:\/|$)/.test(pathname)
  )
}

export function isForgeSphereProxyDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_FORGESPHERE_PROXY_DATA_MODE ?? 'live',
) {
  return (
    mode === 'dummy' && /^\/resources\/forgesphere-proxy(?:\/|$)/.test(pathname)
  )
}

export function isForgeSphereFunctionDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_FORGESPHERE_FUNCTION_DATA_MODE ?? 'live',
) {
  return (
    mode === 'dummy' &&
    /^\/resources\/forgesphere-function(?:\/|$)/.test(pathname)
  )
}

export function isMcpDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_MCP_DATA_MODE ?? 'live',
) {
  return mode === 'dummy' && /^\/resources\/mcp(?:\/|$)/.test(pathname)
}

export function isGovernanceDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_GOVERNANCE_DATA_MODE ?? 'live',
) {
  return mode === 'dummy' && /^\/publish\/governance(?:\/|$)/.test(pathname)
}

/** Onboarding uses the API by default. Demo data is an explicit local preview only. */
export function isOnboardingDemoRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
  mode = import.meta.env.VITE_ONBOARDING_DATA_MODE ?? 'live',
) {
  return (
    !import.meta.env.PROD &&
    mode === 'dummy' &&
    /^\/onboard(?:\/|$)/.test(pathname)
  )
}

export function isDemoDataRoute(
  pathname = typeof window === 'undefined' ? '' : window.location.pathname,
) {
  return (
    isMicroserviceDemoRoute(pathname) ||
    isApigeeProxyDemoRoute(pathname) ||
    isApigeeSharedFlowDemoRoute(pathname) ||
    isKongGatewayServiceDemoRoute(pathname) ||
    isForgeSphereProxyDemoRoute(pathname) ||
    isForgeSphereFunctionDemoRoute(pathname) ||
    isMcpDemoRoute(pathname) ||
    isGovernanceDemoRoute(pathname) ||
    isOnboardingDemoRoute(pathname)
  )
}
